const base = '/payments'

export const payment = {
    payment: `${base}`,
    intializeTransaction: `${base}/initialize`,
    getServices: `/service/clinicals`,
    getCurrentPolicy: `/policy/current`
}